<template>
    <md-button title="View PDF" class="md-info md-just-icon md-round" @click.stop="handleGeneratePdf(invoiceId)">
        <md-icon>preview</md-icon>
    </md-button>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { handleRequests, showErrorMessage, openFile } from '@/helpers';

export default {
    name: 'GeneratePdfButton',
    props: {
        invoiceId: {
            type: [Number, String],
            default: () => null
        },
        paymentSummary: {
            type: Boolean,
            default: false
        }
    },
    mixins: [GeneralMixin],
    methods: {
        async handleGeneratePdf(invoiceId) {
            this.$_handleLoaderState(true, 'GENERATING...');
            const payload = {
                method: 'get',
                responseType: 'blob'
            };
            const api = `/api/team-member-invoices/${invoiceId}/${this.paymentSummary}/download`;
            try {
                const response = await handleRequests(api, payload);
                await openFile(response.data, 'invoice.pdf');
                this.$notify({
                    message: 'Successfully generated a PDF',
                    type: 'success'
                });
                this.$emit('invoiceGenerated', true);
            } catch (e) {
                const message = 'Error in generating invoice.';
                showErrorMessage(this, message, e);
            }
            this.$_handleLoaderState(false);
        }
    }
};
</script>
